import { PlayerModalPlayerData } from "@shared/playerApiTypes";
import { TooltipProvider } from "@/components/ui/tooltip";
import MultiIdsList from "@/components/MultiIdsList";
import { txToast } from "@/components/TxToaster";
import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";


type PlayerIdsTabProps = {
    player: PlayerModalPlayerData;
    refreshModalData: () => void;
}

export default function PlayerIdsTab({ player, refreshModalData }: PlayerIdsTabProps) {
    // const [ids, setIds] = useState(player?.oldIds ?? []);
    // const [hwids, setHwids] = useState(player?.oldHwids ?? []);
    // const onWipeIds = () => {
    //     //TODO: Implement the wipe IDs logic
    //     // refreshModalData();
    //     console.log('Wiping IDs...');
    //     txToast.success('IDs wiped successfully.');
    //     setIds((player?.oldIds ?? []).filter((id) => id.startsWith('license:')));
    // }
    // const onWipeHwids = () => {
    //     //TODO: Implement the wipe IDs logic
    //     // refreshModalData();
    //     console.log('Wiping IDs...');
    //     txToast.success('HWIDs wiped successfully.');
    //     setHwids([]);
    // }

    const { copy, copied } = useCopyToClipboard();
    const allIds = [...(player?.oldIds ?? []), ...(player?.ids ?? [])];
    const allHwids = [...(player?.oldHwids ?? []), ...(player?.hwids ?? [])];
    const allText = [...allIds, ...allHwids].join('\n');

    return <TooltipProvider>
        <div className="flex flex-col gap-4 p-1">
            {/* Copy-all header */}
            <div className="flex items-center justify-between">
                <span className="text-[9px] font-bold tracking-[0.15em] uppercase" style={{ color: 'var(--sc-muted)' }}>
                    Identifiers · {allIds.length + allHwids.length}
                </span>
                <button
                    onClick={() => copy(allText)}
                    className="flex items-center gap-1.5 px-2 py-1 rounded-md text-xs transition-colors"
                    style={{
                        background: 'var(--sc-bg-elevated)',
                        border: '1px solid var(--sc-border)',
                        color: copied === allText ? 'var(--sc-green)' : 'var(--sc-cyan)',
                    }}
                >
                    {copied === allText ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
                    Copy all
                </button>
            </div>
            <MultiIdsList
                type='id'
                src='player'
                list={player?.oldIds ?? []}
                highlighted={player.ids}
            // onWipeIds={onWipeIds}
            />
            <MultiIdsList
                type='hwid'
                src='player'
                list={player?.oldHwids ?? []}
                highlighted={player.hwids}
            // onWipeIds={onWipeIds}
            />
        </div>
    </TooltipProvider>;
}
